import { createSelector } from '@reduxjs/toolkit';

export const selectAuthSlice = (state) => state.auth;

export const selectUser = createSelector([selectAuthSlice], (authSlice) => authSlice.user);

export const selectFormErrorText = createSelector([selectAuthSlice], (authSlice) => authSlice.formErrorText);

export const selectAuthenticationInProgress = createSelector([selectAuthSlice], (authSlice) => authSlice.authenticationInProgress);

export const selectAuthenticationError = createSelector([selectAuthSlice], (authSlice) => authSlice.authenticationError);

export const selectRedirectUrl = createSelector([selectAuthSlice], (authSlice) => authSlice.redirectUrl);

export const selectAuthProviderConfig = createSelector([selectAuthSlice], (authSlice) => authSlice.authProviderConfig);

export const selectMfaRequired = createSelector([selectAuthSlice], (authSlice) => authSlice.mfaRequired);
export const selectPendingCredentials = createSelector([selectAuthSlice], (authSlice) => authSlice.pendingCredentials);